<template>
  <v-footer class="footer-section" :app="isFixed" :fixed="isFixed">
    <div class="footer-image__container" :class="{ 'd-none': !isFixed || !isVisibleImage }">
      <v-img
        cover
        :src="
          $vuetify.breakpoint.smAndDown ? FooterMobileFrame : FooterDesktopFrame
        "
        alt="footer image"
      ></v-img>
    </div>
    <div class="footer-text">
      <p class="my-0">
        Produced by Taste & Aroma Strategic Research Institute Co.,Ltd.
      </p>
    </div>
  </v-footer>
</template>
<script>
import FooterDesktopFrame from "@/assets/footer_frame_desktop.png";
import FooterMobileFrame from "@/assets/footer_frame_mobile.png";

export default {
  data() {
    return {
      FooterDesktopFrame,
      FooterMobileFrame,
    };
  },
  props: {
    isFixed: {
      type: Boolean,
      default: true,
    },
    isVisibleImage: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    console.log(this.isFixed);
  },
};
</script>
<style scoped>
.footer-section {
  width: 100vw;
  background-color: transparent !important;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 0px;
  z-index: 0;
}
.footer-image__container {
  width: 100%;
  z-index: 0;
}
.footer-text {
  width: 100vw;
  background-color: #b6afab !important;
  text-align: center;
  font-size: 13px;
  padding: 1.2rem;
  margin: 0px;
  z-index: 0;
}
</style>
